(function () {
  var TRASH_LABEL = 'Artikel entfernen';
  var MINUS_LABEL = 'Menge verringern';

  function stepOf(input) {
    return parseInt(input.step, 10) || 1;
  }

  // Minus wird zum Papierkorb, wenn die naechste Verringerung unter 1 fallen wuerde
  function setMinusState(wrapper, quantity) {
    var input = wrapper.querySelector('input.quantity-input');
    var minus = wrapper.querySelector('[data-qty-step="-1"]');
    if (!input || !minus) return;

    var isTrash = quantity - stepOf(input) < 1;
    minus.disabled = false;
    minus.toggleAttribute('data-trash', isTrash);
    minus.setAttribute('aria-label', isTrash ? TRASH_LABEL : MINUS_LABEL);
  }

  function syncAll() {
    document.querySelectorAll('.qty-stepper').forEach(function (wrapper) {
      var input = wrapper.querySelector('input.quantity-input');
      if (input) setMinusState(wrapper, parseInt(input.value, 10) || 1);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;

    var wrapper = button.closest('.qty-stepper');
    var input = wrapper && wrapper.querySelector('input.quantity-input');
    if (!input) return;

    var step = stepOf(input);
    var direction = parseInt(button.dataset.qtyStep, 10);
    var current = parseInt(input.value, 10) || 1;

    // Papierkorb: Artikel ueber den vorhandenen Entfernen-Link des Themes loeschen
    if (direction < 0 && current - step < 1) {
      if (button.dataset.removing) return;
      var holder = button.closest('line-item-quantity');
      var removeLink = holder && holder.querySelector('a[href*="quantity=0"]');
      if (!removeLink) return;

      button.dataset.removing = '1';
      setTimeout(function () { delete button.dataset.removing; }, 1500);
      removeLink.click();
      return;
    }

    var next = current + direction * step;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    next = Math.max(1, Math.min(next, max));
    if (next === current) return;

    input.value = next;
    setMinusState(wrapper, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Auch bei Handeingabe nie unter 1 gehen (Capture-Phase, laeuft vor dem Theme-Code)
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('.qty-stepper input.quantity-input')) return;
    if (!(parseInt(input.value, 10) >= 1)) input.value = 1;
    setMinusState(input.closest('.qty-stepper'), parseInt(input.value, 10));
  }, true);

  // Nach dem Neuladen des Warenkorbs (Seite, Drawer) den Zustand der Buttons neu setzen
  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  function init() {
    syncAll();
    new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();